(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ep-age-gate"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'ep-age-gate-verified';
    var SESSION_KEY = 'ep-age-gate-tagged';

    function ready(fn) {
      if (document.readyState !== 'loading') { fn(); }
      else { document.addEventListener('DOMContentLoaded', fn); }
    }

    function isVerified() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return false;
        var until = parseInt(raw, 10);
        if (isNaN(until)) return false;
        if (Date.now() > until) {
          window.localStorage.removeItem(STORAGE_KEY);
          return false;
        }
        return true;
      } catch (e) {
        return false;
      }
    }

    /* Riporta la conferma del popup sull'ordine: scrive un attributo del carrello, che
       resta visibile nei dettagli ordine in admin. Nessun clic in piu per l'utente. */
    function tagCart(label) {
      if (!label) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var attrs = {};
      var d = new Date();
      var gg = ('0' + d.getDate()).slice(-2);
      var mm = ('0' + (d.getMonth() + 1)).slice(-2);
      attrs[label] = 'Confermata il ' + gg + '/' + mm + '/' + d.getFullYear();
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      })
        .then(function () { try { window.sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {} })
        .catch(function () {});
    }

    function setVerified(days) {
      try {
        var ms = (parseInt(days, 10) || 30) * 24 * 60 * 60 * 1000;
        window.localStorage.setItem(STORAGE_KEY, String(Date.now() + ms));
      } catch (e) {}
    }

    ready(function () {
      var gate = document.querySelector('[data-ep-age-gate]');
      if (!gate) return;

      var attrLabel = gate.getAttribute('data-order-attribute');

      if (isVerified()) {
        document.documentElement.classList.add('ep-age-gate-ok');
        /* Conferma gia data in una sessione precedente: il carrello pero puo essere nuovo,
           quindi l'attributo va riscritto. Una volta sola per sessione. */
        var tagged = false;
        try { tagged = !!window.sessionStorage.getItem(SESSION_KEY); } catch (e) {}
        if (!tagged) tagCart(attrLabel);
        gate.parentNode && gate.parentNode.removeChild(gate);
        return;
      }

      var ask = gate.querySelector('[data-ep-age-ask]');
      var denied = gate.querySelector('[data-ep-age-denied]');
      var confirmBtn = gate.querySelector('[data-ep-age-confirm]');
      var denyBtn = gate.querySelector('[data-ep-age-deny]');
      var terms = gate.querySelector('[data-ep-age-terms]');
      var requireTerms = gate.hasAttribute('data-require-terms');

      function lock() { document.documentElement.classList.add('ep-age-gate-locked'); }
      function unlock() { document.documentElement.classList.remove('ep-age-gate-locked'); }

      function syncConfirm() {
        if (!confirmBtn) return;
        if (requireTerms && terms && !terms.checked) {
          confirmBtn.setAttribute('disabled', '');
        } else {
          confirmBtn.removeAttribute('disabled');
        }
      }

      lock();
      syncConfirm();
      terms && terms.addEventListener('change', syncConfirm);

      if (requireTerms && terms) { terms.focus(); }
      else if (confirmBtn) { confirmBtn.focus(); }

      confirmBtn && confirmBtn.addEventListener('click', function () {
        if (requireTerms && terms && !terms.checked) { terms.focus(); return; }
        setVerified(gate.getAttribute('data-remember-days'));
        tagCart(attrLabel);
        document.documentElement.classList.add('ep-age-gate-ok');
        unlock();
        gate.parentNode && gate.parentNode.removeChild(gate);
      });

      denyBtn && denyBtn.addEventListener('click', function () {
        if (ask) ask.setAttribute('hidden', '');
        if (denied) {
          denied.removeAttribute('hidden');
          denied.setAttribute('tabindex', '-1');
          denied.focus();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-brands"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ep-brands]').forEach(function (root) {
      /* Fallback logo a due stadi: se la 1ª estensione va in 404 ritento con l'altra
         (data-ep-logo-fallback); se falliscono entrambe rimuovo l'immagine e valorizzo il nome. */
      root.querySelectorAll('[data-ep-brand-logo]').forEach(function (img) {
        var fallback = img.getAttribute('data-ep-logo-fallback');
        var triedFallback = false;
        function fail() {
          var tile = img.closest('.ep-brands__tile');
          if (tile) tile.classList.add('is-nologo');
          if (img.parentNode) img.parentNode.removeChild(img);
        }
        function onError() {
          if (fallback && !triedFallback && img.getAttribute('src') !== fallback) {
            triedFallback = true;
            img.setAttribute('src', fallback);
            return;
          }
          fail();
        }
        img.addEventListener('error', onError);
        if (!img.getAttribute('src')) { fail(); return; }
        /* immagine già fallita prima che il listener fosse agganciato (404 in cache) */
        if (img.complete && img.naturalWidth === 0) { onError(); }
      });

      /* Ricerca live: filtra le mattonelle della pagina corrente e nasconde le righe-lettera vuote */
      var input = root.querySelector('[data-ep-brands-search]');
      var noResult = root.querySelector('[data-ep-brands-noresult]');
      var alpha = root.querySelector('[data-ep-brands-alpha]');
      var grid = root.querySelector('[data-ep-brands-grid]');
      if (input && grid) {
        input.addEventListener('input', function () {
          var q = input.value.trim().toLowerCase();
          var anyGlobal = false;
          grid.querySelectorAll('.ep-brands__cell').forEach(function (c) {
            var name = (c.getAttribute('data-ep-brand-name') || '').toLowerCase();
            var show = !q || name.indexOf(q) !== -1;
            c.hidden = !show;
            if (show) anyGlobal = true;
          });
          grid.querySelectorAll('[data-ep-brands-letter]').forEach(function (row) {
            var any = false;
            var el = row.nextElementSibling;
            while (el && !el.hasAttribute('data-ep-brands-letter')) {
              if (el.classList.contains('ep-brands__cell') && !el.hidden) { any = true; break; }
              el = el.nextElementSibling;
            }
            row.hidden = !any;
          });
          if (alpha) alpha.style.display = q ? 'none' : '';
          if (noResult) noResult.hidden = anyGlobal;
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var section = document.querySelector('[data-ep-cart-section]');
    if (!section) return;
    var sectionId = section.getAttribute('data-ep-cart-section');
    var noteTimer = null;

    function setLoading(on) { section.classList.toggle('is-loading', on); }

    function refreshFromSections(sections) {
      if (!sections || !sections[sectionId]) { window.location.reload(); return; }
      var parsed = new DOMParser().parseFromString(sections[sectionId], 'text/html');
      var fresh = parsed.querySelector('[data-ep-cart-root]');
      var current = section.querySelector('[data-ep-cart-root]');
      if (fresh && current) { current.innerHTML = fresh.innerHTML; }
      else { window.location.reload(); }
    }

    function change(key, qty) {
      if (!window.fetch) return;
      setLoading(true);
      fetch(root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: sectionId, sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); })
        .then(function (data) {
          refreshFromSections(data.sections);
          setLoading(false);
          document.dispatchEvent(new CustomEvent('ep:cart:changed'));
        }).catch(function () { setLoading(false); });
    }

    /* Delego sull'elemento sezione (stabile): il contenuto interno viene sostituito */
    section.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-ep-cart-remove]');
      if (rm) { e.preventDefault(); var it = rm.closest('[data-key]'); if (it) change(it.getAttribute('data-key'), 0); return; }
      var q = e.target.closest('.ep-cart__qty');
      if (!q) return;
      var inp = q.querySelector('[data-ep-cart-qty]');
      var cur = parseInt(inp.value, 10) || 1;
      if (e.target.closest('[data-ep-cart-minus]')) change(q.getAttribute('data-key'), Math.max(0, cur - 1));
      else if (e.target.closest('[data-ep-cart-plus]')) change(q.getAttribute('data-key'), cur + 1);
    });
    section.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-ep-cart-qty]');
      if (!inp) return;
      var q = inp.closest('.ep-cart__qty');
      change(q.getAttribute('data-key'), Math.max(0, parseInt(inp.value, 10) || 0));
    });

    /* --- Confezione regalo ---------------------------------------------------
       Il cliente compone N confezioni e assegna a ognuna delle bottiglie prese
       dal carrello. Lo stato vive negli attributi del carrello (quindi arriva
       sull ordine e sopravvive al ricaricamento), il costo e una riga del
       prodotto servizio con quantita pari al numero di confezioni.
       I prodotti sono tutti a variante singola: il titolo identifica la riga. */
    var giftState = [];

    function giftEl() { return section.querySelector('[data-ep-gift]'); }

    function giftCartQty(box) {
      var map = {}, order = [];
      var rows = box.querySelector('[data-ep-gift-tpl]').content.querySelectorAll('[data-ep-alloc]');
      for (var i = 0; i < rows.length; i++) {
        var t = rows[i].getAttribute('data-title');
        map[t] = parseInt(rows[i].getAttribute('data-cart-qty'), 10) || 0;
        order.push(t);
      }
      return { map: map, order: order };
    }

    function giftAssigned(title) {
      var n = 0;
      for (var i = 0; i < giftState.length; i++) n += giftState[i].items[title] || 0;
      return n;
    }

    function giftFree(cart, title) {
      return (cart.map[title] || 0) - giftAssigned(title);
    }

    function giftAnyFree(cart) {
      for (var i = 0; i < cart.order.length; i++) if (giftFree(cart, cart.order[i]) > 0) return true;
      return false;
    }

    /* Il carrello puo cambiare dopo la composizione: taglia le assegnazioni ai
       pezzi realmente presenti e butta le confezioni rimaste vuote. */
    function giftReconcile(cart) {
      var box = giftEl();
      var maxBott = box ? (parseInt(box.getAttribute('data-max-bottiglie'), 10) || 12) : 12;
      var used = {}, kept = [];
      for (var i = 0; i < giftState.length; i++) {
        var b = giftState[i], items = {}, any = false, dentro = 0;
        for (var t in b.items) {
          if (!Object.prototype.hasOwnProperty.call(b.items, t)) continue;
          var avail = (cart.map[t] || 0) - (used[t] || 0);
          var q = Math.min(b.items[t], Math.max(0, avail), Math.max(0, maxBott - dentro));
          if (q > 0) { items[t] = q; used[t] = (used[t] || 0) + q; dentro += q; any = true; }
        }
        if (any) kept.push({ items: items, note: b.note || '' });
      }
      giftState = kept;
    }

    function giftMoney(cents) {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'it', { style: 'currency', currency: cur }).format(cents / 100);
      } catch (err) { return (cents / 100).toFixed(2); }
    }

    function giftRender() {
      var box = giftEl();
      if (!box) return;
      var cart = giftCartQty(box);
      var host = box.querySelector('[data-ep-gift-boxes]');
      var tpl = box.querySelector('[data-ep-gift-tpl]');
      var labelBox = box.getAttribute('data-label-box');
      var labelLeft = box.getAttribute('data-label-left');
      var maxBoxes = parseInt(box.getAttribute('data-max-boxes'), 10) || 20;
      var maxBott = parseInt(box.getAttribute('data-max-bottiglie'), 10) || 12;
      host.textContent = '';

      for (var i = 0; i < giftState.length; i++) {
        var node = tpl.content.cloneNode(true);
        var el = node.querySelector('[data-ep-box]');
        el.querySelector('[data-ep-box-name]').textContent = labelBox + ' ' + (i + 1);
        el.querySelector('[data-ep-box-note]').value = giftState[i].note || '';
        /* Quante bottiglie stanno gia' in questa confezione: oltre il tetto il piu' si spegne,
           perche' la scatola e' quella e non ci sta altro. */
        var dentro = 0;
        for (var k in giftState[i].items) {
          if (Object.prototype.hasOwnProperty.call(giftState[i].items, k)) dentro += giftState[i].items[k];
        }
        var pieno = dentro >= maxBott;
        var contatore = el.querySelector('[data-ep-box-count]');
        if (contatore) {
          contatore.textContent = dentro + '/' + maxBott;
          contatore.classList.toggle('ep-cart__box-count--pieno', pieno);
        }
        var rows = el.querySelectorAll('[data-ep-alloc]');
        for (var j = 0; j < rows.length; j++) {
          var t = rows[j].getAttribute('data-title');
          var q = giftState[i].items[t] || 0;
          var free = giftFree(cart, t);
          rows[j].querySelector('[data-ep-alloc-val]').textContent = String(q);
          rows[j].querySelector('[data-ep-alloc-minus]').disabled = q === 0;
          rows[j].querySelector('[data-ep-alloc-plus]').disabled = free <= 0 || pieno;
          rows[j].querySelector('[data-ep-alloc-left]').textContent = free + ' ' + labelLeft;
          rows[j].classList.toggle('ep-cart__alloc--off', q === 0);
        }
        host.appendChild(node);
      }

      var n = giftState.length;
      var unit = parseInt(box.getAttribute('data-price'), 10) || 0;
      var word = n === 1 ? box.getAttribute('data-label-one') : box.getAttribute('data-label-many');
      var sep = ' \u2014 ';
      box.querySelector('[data-ep-gift-total]').textContent = n > 0 ? (n + ' ' + word + sep + giftMoney(unit * n)) : '';
      box.querySelector('[data-ep-gift-add]').disabled = n >= maxBoxes || (n > 0 && !giftAnyFree(cart));
      box.querySelector('[data-ep-gift-done]').hidden = true;
    }

    /* Impronta del contenuto delle confezioni: serve solo a capire se la riconciliazione
       ha cambiato qualcosa rispetto a com'era salvato. */
    function giftSignature(list) {
      var out = [];
      for (var k = 0; k < list.length; k++) {
        var parts = [];
        for (var t in list[k].items) {
          if (!Object.prototype.hasOwnProperty.call(list[k].items, t)) continue;
          if (list[k].items[t] > 0) parts.push(list[k].items[t] + ' x ' + t);
        }
        if (parts.length) out.push(parts.join(' | ') + ' || ' + (list[k].note || '').trim());
      }
      return out.join(' ## ');
    }

    function giftApply() {
      var box = giftEl();
      if (!box || !window.fetch) return;
      var prefix = box.getAttribute('data-attr-prefix');
      var noteKey = box.getAttribute('data-attr-note');
      var maxBoxes = parseInt(box.getAttribute('data-max-boxes'), 10) || 20;
      var attrs = {};
      for (var i = 1; i <= maxBoxes; i++) {
        attrs[prefix + ' ' + i] = '';
        attrs[prefix + ' ' + i + ' - ' + noteKey] = '';
      }
      var valid = [];
      for (var k = 0; k < giftState.length; k++) {
        var parts = [];
        for (var t in giftState[k].items) {
          if (!Object.prototype.hasOwnProperty.call(giftState[k].items, t)) continue;
          if (giftState[k].items[t] > 0) parts.push(giftState[k].items[t] + ' x ' + t);
        }
        if (parts.length) valid.push({ text: parts.join(' | '), note: (giftState[k].note || '').trim() });
      }
      for (var m = 0; m < valid.length && m < maxBoxes; m++) {
        attrs[prefix + ' ' + (m + 1)] = valid[m].text;
        if (valid[m].note) attrs[prefix + ' ' + (m + 1) + ' - ' + noteKey] = valid[m].note;
      }
      var updates = {};
      updates[box.getAttribute('data-variant-id')] = valid.length;
      setLoading(true);
      fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates, attributes: attrs, sections: sectionId, sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); })
        .then(function (data) {
          refreshFromSections(data.sections);
          setLoading(false);
          giftLoad(true);
          document.dispatchEvent(new CustomEvent('ep:cart:changed'));
        }).catch(function () { setLoading(false); });
    }

    function giftLoad(showDone) {
      if (!giftEl() || !window.fetch) return;
      fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var fresh = giftEl();
          if (!fresh) return;
          var prefix = fresh.getAttribute('data-attr-prefix');
          var noteKey = fresh.getAttribute('data-attr-note');
          var maxBoxes = parseInt(fresh.getAttribute('data-max-boxes'), 10) || 20;
          var attrs = data.attributes || {};
          var re = new RegExp('^(\\d+) x ([\\s\\S]+)$');
          giftState = [];
          for (var i = 1; i <= maxBoxes; i++) {
            var raw = attrs[prefix + ' ' + i];
            if (!raw) continue;
            var items = {};
            var pieces = String(raw).split(' | ');
            for (var p = 0; p < pieces.length; p++) {
              var m = re.exec(pieces[p]);
              if (m) items[m[2]] = (items[m[2]] || 0) + (parseInt(m[1], 10) || 0);
            }
            giftState.push({ items: items, note: attrs[prefix + ' ' + i + ' - ' + noteKey] || '' });
          }
          /* La riconciliazione tocca solo lo stato in pagina: se ha davvero cambiato
             qualcosa (bottiglia tolta dal carrello, quantita ridotta) va riscritta anche
             sul carrello, altrimenti restano attributi e riga servizio di confezioni che
             non esistono piu. giftApply ricarica da solo, quindi qui si esce. */
          var sigPrima = giftSignature(giftState);
          giftReconcile(giftCartQty(fresh));
          if (giftSignature(giftState) !== sigPrima) { giftApply(); return; }
          var on = giftState.length > 0;
          fresh.querySelector('[data-ep-gift-toggle]').checked = on;
          fresh.querySelector('[data-ep-gift-body]').hidden = !on;
          giftRender();
          if (showDone && on) fresh.querySelector('[data-ep-gift-done]').hidden = false;
        }).catch(function () {});
    }

    function giftIndex(node) {
      var el = node.closest('[data-ep-box]');
      if (!el) return -1;
      return Array.prototype.indexOf.call(el.parentNode.children, el);
    }

    section.addEventListener('click', function (e) {
      var box = giftEl();
      if (!box) return;

      if (e.target.closest('[data-ep-gift-add]')) {
        var maxBoxes = parseInt(box.getAttribute('data-max-boxes'), 10) || 20;
        if (giftState.length < maxBoxes) { giftState.push({ items: {}, note: '' }); giftRender(); }
        return;
      }
      if (e.target.closest('[data-ep-box-del]')) {
        var di = giftIndex(e.target);
        if (di > -1) { giftState.splice(di, 1); giftRender(); }
        return;
      }
      if (e.target.closest('[data-ep-gift-apply]')) { giftApply(); return; }

      var step = e.target.closest('[data-ep-alloc-plus], [data-ep-alloc-minus]');
      if (!step) return;
      var bi = giftIndex(step);
      if (bi < 0) return;
      var title = step.closest('[data-ep-alloc]').getAttribute('data-title');
      var cur = giftState[bi].items[title] || 0;
      if (step.hasAttribute('data-ep-alloc-plus')) {
        if (giftFree(giftCartQty(box), title) > 0) giftState[bi].items[title] = cur + 1;
      } else if (cur > 0) {
        if (cur === 1) delete giftState[bi].items[title];
        else giftState[bi].items[title] = cur - 1;
      }
      giftRender();
    });

    section.addEventListener('change', function (e) {
      var t = e.target.closest('[data-ep-gift-toggle]');
      if (!t) return;
      var box = giftEl();
      if (!box) return;
      box.querySelector('[data-ep-gift-body]').hidden = !t.checked;
      if (t.checked) {
        if (!giftState.length) giftState.push({ items: {}, note: '' });
        giftRender();
      } else {
        giftState = [];
        giftRender();
        giftApply();
      }
    });

    section.addEventListener('input', function (e) {
      var note = e.target.closest('[data-ep-cart-note]');
      if (!note) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        if (!window.fetch) return;
        fetch(root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
      }, 600);
    });

    section.addEventListener('input', function (e) {
      var n = e.target.closest('[data-ep-box-note]');
      if (!n) return;
      var bi = giftIndex(n);
      if (bi > -1) giftState[bi].note = n.value;
    });

    document.addEventListener('ep:cart:changed', function () { giftLoad(false); });
    giftLoad(false);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-contatti"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mapEl = document.querySelector('[data-ep-map]');
    if (!mapEl) return;
    var stores = [].slice.call(document.querySelectorAll('[data-ep-store]')).map(function (el) {
      return { name: el.getAttribute('data-name'), address: el.getAttribute('data-address'),
        lat: parseFloat(el.getAttribute('data-lat')), lng: parseFloat(el.getAttribute('data-lng')) };
    }).filter(function (s) { return !isNaN(s.lat) && !isNaN(s.lng); });
    if (!stores.length) return;

    var PIN = '<svg viewBox="0 0 24 24"><path d="M12 23s-7.5-6.4-7.5-12.3a7.5 7.5 0 0 1 15 0C19.5 16.6 12 23 12 23z"></path><circle class="ep-contatti__marker-dot" cx="12" cy="10.5" r="2.8"></circle></svg>';

    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

    function init() {
      var L = window.L;
      var map = L.map(mapEl, { scrollWheelZoom: false, zoomControl: true });
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: 19
      }).addTo(map);
      var icon = L.divIcon({ className: 'ep-contatti__marker', html: PIN, iconSize: [34, 34], iconAnchor: [17, 34], popupAnchor: [0, -30] });
      var bounds = [];
      stores.forEach(function (s) {
        L.marker([s.lat, s.lng], { icon: icon, title: s.name }).addTo(map)
          .bindPopup('<b>' + esc(s.name) + '</b>' + esc(s.address));
        bounds.push([s.lat, s.lng]);
      });
      if (bounds.length > 1) map.fitBounds(bounds, { padding: [48, 48] });
      else map.setView(bounds[0], 15);
    }

    function load() {
      if (window.L) { init(); return; }
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(css);
      var js = document.createElement('script');
      js.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      js.onload = init;
      document.head.appendChild(js);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '300px' });
      io.observe(mapEl);
    } else {
      load();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ep-faq').forEach(function (root) {
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-ep-faq-jump]'));
    if (!links.length) return;

    var groups = links.map(function (a) {
      return root.querySelector('[id="' + a.getAttribute('href').slice(1) + '"]');
    });
    var HEAD_OFFSET = 110;

    links.forEach(function (a, i) {
      a.addEventListener('click', function (event) {
        if (!groups[i]) return;
        event.preventDefault();
        var y = groups[i].getBoundingClientRect().top + window.pageYOffset - HEAD_OFFSET;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });

    var spy = function () {
      var current = 0;
      groups.forEach(function (g, i) {
        if (g && g.getBoundingClientRect().top <= 150) current = i;
      });
      links.forEach(function (a, i) {
        a.classList.toggle('is-on', i === current);
      });
    };

    spy();
    window.addEventListener('scroll', spy, { passive: true });
    window.addEventListener('resize', spy);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-footer"] && !Shopify.designMode) return;
  try {
    
  /* Loader ufficiale iubenda per i link alle policy (classe iubenda-embed): caricato a pagina
     pronta, solo se nel footer c'e' almeno un link del genere. */
  window.addEventListener('load', function () {
    if (!document.querySelector('.ep-footer .iubenda-embed')) return;
    var s = document.createElement('script');
    s.src = 'https://cdn.iubenda.com/iubenda.js';
    document.head.appendChild(s);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-header"]) return;
  try {
    
  document.querySelectorAll('[data-ep-header]').forEach(function (root) {
    var burger = root.querySelector('.ep-header__burger');
    var menu = root.querySelector('[data-ep-mega]');
    if (!burger || !menu) return;
    burger.addEventListener('click', function () {
      var open = menu.classList.toggle('ep-mega--open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  (function () {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    /* Aggiorna il badge del carrello ovunque compaia */
    function setCount(n) {
      document.querySelectorAll('[data-ep-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.classList.toggle('is-empty', !n || n < 1);
        if (n > 0) {
          el.classList.remove('is-bump');
          void el.offsetWidth;
          el.classList.add('is-bump');
        }
      });
    }
    function refreshCount() {
      if (!window.fetch) return;
      fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count); })
        .catch(function () {});
    }

    /* Toast */
    var toast = document.querySelector('[data-ep-cart-toast]');
    var toastImg = toast && toast.querySelector('[data-ep-toast-img]');
    var toastTitle = toast && toast.querySelector('[data-ep-toast-title]');
    var hideTimer = null;
    function closeToast() {
      if (!toast) return;
      toast.classList.remove('is-open');
      clearTimeout(hideTimer);
      setTimeout(function () { toast.hidden = true; }, 300);
    }
    function openToast(detail) {
      if (!toast) return;
      if (toastTitle) toastTitle.textContent = (detail && detail.title) || '';
      if (toastImg) {
        if (detail && detail.image) { toastImg.src = detail.image; toastImg.hidden = false; }
        else { toastImg.hidden = true; toastImg.removeAttribute('src'); }
      }
      toast.hidden = false;
      void toast.offsetWidth;
      toast.classList.add('is-open');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(closeToast, 4500);
    }
    if (toast) {
      toast.querySelectorAll('[data-ep-toast-close]').forEach(function (b) {
        b.addEventListener('click', closeToast);
      });
    }

    /* ===== Cart drawer ===== */
    var drawer = document.querySelector('[data-ep-cart-drawer]');
    var panel = drawer && drawer.querySelector('.ep-cd__panel');
    var body = drawer && drawer.querySelector('[data-ep-cd-body]');
    var footEl = drawer && drawer.querySelector('[data-ep-cd-foot]');
    var emptyEl = drawer && drawer.querySelector('[data-ep-cd-empty]');
    var countEl = drawer && drawer.querySelector('[data-ep-cd-count]');
    var subEl = drawer && drawer.querySelector('[data-ep-cd-subtotal]');
    var noteEl = drawer && drawer.querySelector('[data-ep-cd-note]');
    var ageEl = drawer && drawer.querySelector('[data-ep-cd-age]');
    var termsEl = drawer && drawer.querySelector('[data-ep-cd-terms]');
    var checkoutEl = drawer && drawer.querySelector('[data-ep-cd-checkout]');
    var TOK_OPEN = '{' + '{', TOK_CLOSE = '}' + '}';
    var moneyFmt = (panel && panel.getAttribute('data-money-format')) || ('€' + TOK_OPEN + 'amount_with_comma_separator' + TOK_CLOSE);
    var removeLabel = panel ? (panel.getAttribute('data-remove-label') || 'Rimuovi') : 'Rimuovi';
    var giftVid = panel ? (panel.getAttribute('data-gift-variant') || '') : '';
    var lastFocus = null, noteTimer = null;

    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    function formatMoney(cents) {
      if (typeof cents === 'string') cents = cents.replace(/[^0-9-]/g, '');
      var rx = /\{\{\s*(\w+)\s*\}\}/;
      function fmt(precision, thousands, decimal) {
        if (isNaN(cents) || cents == null) return '0';
        var n = (cents / 100).toFixed(precision);
        var parts = n.split('.');
        var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return whole + (parts[1] ? decimal + parts[1] : '');
      }
      var m = moneyFmt.match(rx), t = m ? m[1] : 'amount', val;
      switch (t) {
        case 'amount_no_decimals': val = fmt(0, ',', '.'); break;
        case 'amount_with_comma_separator': val = fmt(2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': val = fmt(0, '.', ','); break;
        case 'amount_with_apostrophe_separator': val = fmt(2, "'", '.'); break;
        case 'amount_with_space_separator': val = fmt(2, ' ', ','); break;
        default: val = fmt(2, ',', '.');
      }
      return moneyFmt.replace(rx, val);
    }

    /* Conferma maggiore eta: stato volatile, vive solo nella checkbox in pagina.
       Il footer non viene rigenerato dal render (si rigenera solo il corpo), ma la
       risincronizzazione dopo ogni render tiene il bottone coerente in ogni caso. */
    function syncAgeGate() {
      if (!checkoutEl) return;
      var locked = (!!ageEl && !ageEl.checked) || (!!termsEl && !termsEl.checked);
      checkoutEl.disabled = locked;
      checkoutEl.classList.toggle('ep-cd__checkout--locked', locked);
    }

    /* Confezioni regalo: vivono negli attributi del carrello, con le stesse chiavi che
       compaiono nei dettagli dell'ordine ("Confezione 1", "Confezione 1 - biglietto").
       Le chiavi si leggono per forma, non per prefisso: cosi il cassetto resta allineato
       anche se dalla pagina carrello si rinominano prefisso o suffisso. */
    function packsHtml(cart) {
      var attrs = cart.attributes || {};
      var reNote = /^(.+?)\s+(\d+)\s*-\s*(.+)$/;
      var reBox = /^(.+?)\s+(\d+)$/;
      var boxes = {};
      Object.keys(attrs).forEach(function (k) {
        var v = attrs[k];
        if (!v) return;
        var m = reNote.exec(k);
        if (m) {
          boxes[m[2]] = boxes[m[2]] || {};
          boxes[m[2]].noteLabel = m[3];
          boxes[m[2]].note = String(v);
          return;
        }
        m = reBox.exec(k);
        if (!m) return;
        boxes[m[2]] = boxes[m[2]] || {};
        boxes[m[2]].label = k;
        boxes[m[2]].items = String(v).split(' | ');
      });
      var nums = Object.keys(boxes).filter(function (n) { return boxes[n].items && boxes[n].items.length; });
      nums.sort(function (a, b) { return a - b; });
      if (!nums.length) return '';
      return '<div class="ep-cd__packs">' + nums.map(function (n) {
        var b = boxes[n];
        var items = b.items.map(function (t) {
          return '<li>' + esc(String(t).replace(/^(\d+)\s*x\s*/i, '$1 \u00d7 ')) + '</li>';
        }).join('');
        var note = b.note ? '<p class="ep-cd__pack-note"><span>' + esc(b.noteLabel) + ':</span> ' + esc(b.note) + '</p>' : '';
        return '<div class="ep-cd__pack">' +
          '<span class="ep-cd__pack-k">' + esc(b.label) + '</span>' +
          '<ul class="ep-cd__pack-l">' + items + '</ul>' + note +
        '</div>';
      }).join('') + '</div>';
    }

    /* Presidio: le confezioni citano bottiglie per titolo, quindi se una sparisce dal
       carrello (o cala di quantita) l'attributo resta a parlare di roba che non c'e piu,
       e con essa la riga a pagamento del servizio. La pagina carrello si riallinea da
       sola, ma da qui si puo togliere una bottiglia stando su un'altra pagina e andare
       dritti al checkout: la riconciliazione va fatta anche qui. Ritorna true se ha
       scritto, e in quel caso il render arriva dalla risposta dell'aggiornamento. */
    function reconcilePacks(cart) {
      if (giftVid === '' || !window.fetch) return false;
      var attrs = cart.attributes || {};
      var reNote = /^(.+?)\s+(\d+)\s*-\s*(.+)$/;
      var reBox = /^(.+?)\s+(\d+)$/;
      var boxes = {}, prefix = '', noteKey = '';
      Object.keys(attrs).forEach(function (k) {
        var m = reNote.exec(k);
        if (m) {
          boxes[m[2]] = boxes[m[2]] || {};
          boxes[m[2]].note = String(attrs[k] || '');
          prefix = prefix || m[1];
          noteKey = noteKey || m[3];
          return;
        }
        m = reBox.exec(k);
        if (!m) return;
        boxes[m[2]] = boxes[m[2]] || {};
        boxes[m[2]].raw = String(attrs[k] || '');
        prefix = prefix || m[1];
      });
      var nums = Object.keys(boxes);
      if (!nums.length || prefix === '') return false;
      nums.sort(function (a, b) { return a - b; });

      var left = {};
      cart.items.forEach(function (it) {
        if (String(it.variant_id) === giftVid) return;
        left[it.product_title] = (left[it.product_title] || 0) + it.quantity;
      });

      var rePiece = /^(\d+)\s*x\s*([\s\S]+)$/i;
      var puliti = [];
      nums.forEach(function (n) {
        var raw = boxes[n].raw;
        if (!raw) return;
        var parts = [];
        raw.split(' | ').forEach(function (piece) {
          var m = rePiece.exec(piece.trim());
          if (!m) return;
          var titolo = m[2].trim();
          var voluta = parseInt(m[1], 10) || 0;
          var q = Math.min(voluta, left[titolo] || 0);
          if (q <= 0) return;
          left[titolo] -= q;
          parts.push(q + ' x ' + titolo);
        });
        if (parts.length) puliti.push({ text: parts.join(' | '), note: (boxes[n].note || '').trim() });
      });

      var prima = nums.map(function (n) { return (boxes[n].raw || '') + ' || ' + (boxes[n].note || '').trim(); }).join(' ## ');
      var dopo = puliti.map(function (b) { return b.text + ' || ' + b.note; }).join(' ## ');
      if (prima === dopo) return false;

      var nuovi = {};
      nums.forEach(function (n) {
        nuovi[prefix + ' ' + n] = '';
        if (noteKey) nuovi[prefix + ' ' + n + ' - ' + noteKey] = '';
      });
      puliti.forEach(function (b, i) {
        nuovi[prefix + ' ' + (i + 1)] = b.text;
        if (noteKey && b.note) nuovi[prefix + ' ' + (i + 1) + ' - ' + noteKey] = b.note;
      });
      var updates = {};
      updates[giftVid] = puliti.length;
      setLoading(true);
      fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates, attributes: nuovi })
      }).then(function (r) { return r.json(); })
        .then(function (c) { render(c); setLoading(false); document.dispatchEvent(new CustomEvent('ep:cart:changed')); })
        .catch(function () { setLoading(false); });
      return true;
    }

    function render(cart) {
      if (!drawer) return;
      if (reconcilePacks(cart)) return;
      setCount(cart.item_count);
      if (countEl) countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
      if (cart.item_count === 0) {
        body.innerHTML = '';
        body.hidden = true;
        if (emptyEl) emptyEl.hidden = false;
        if (footEl) footEl.hidden = true;
        return;
      }
      body.hidden = false;
      if (emptyEl) emptyEl.hidden = true;
      if (footEl) footEl.hidden = false;
      body.innerHTML = cart.items.map(function (it) {
        var vt = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="ep-cd__vt">' + esc(it.variant_title) + '</div>' : '';
        var vendor = it.vendor ? '<div class="ep-cd__vendor">' + esc(it.vendor) + '</div>' : '';
        var img = '<svg class="ep-cd__ph" viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2"></rect><circle cx="9" cy="10" r="1.6"></circle><path d="M21 16l-5-5-9 9"></path></svg>';
        if (it.image) { var u = it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160'; img = '<img src="' + u + '" alt="" loading="lazy">'; }
        /* La riga del servizio confezione non si tocca dal cassetto: il numero di
           confezioni dipende dalle bottiglie assegnate e si cambia solo dal carrello. */
        var isGift = giftVid !== '' && String(it.variant_id) === giftVid;
        var qty = isGift ? '' :
          '<div class="ep-cd__qty" data-key="' + it.key + '">' +
            '<button type="button" data-ep-cd-minus aria-label="Diminuisci">−</button>' +
            '<input type="text" value="' + it.quantity + '" inputmode="numeric" data-ep-cd-qty aria-label="Quantità">' +
            '<button type="button" data-ep-cd-plus aria-label="Aumenta">+</button>' +
          '</div>';
        return '<article class="ep-cd__item" data-key="' + it.key + '">' +
          '<a class="ep-cd__thumb" href="' + it.url + '">' + img + '</a>' +
          '<div class="ep-cd__info">' + vendor +
            '<a class="ep-cd__name" href="' + it.url + '">' + esc(it.product_title) + '</a>' + vt +
            '<div class="ep-cd__row' + (isGift ? ' ep-cd__row--solo' : '') + '">' + qty +
              '<div class="ep-cd__price">' + formatMoney(it.final_line_price) + '</div>' +
            '</div>' +
            '<button type="button" class="ep-cd__remove" data-ep-cd-remove>' + removeLabel + '</button>' +
            (isGift ? packsHtml(cart) : '') +
          '</div>' +
        '</article>';
      }).join('');
      if (subEl) subEl.textContent = formatMoney(cart.total_price);
      if (noteEl && document.activeElement !== noteEl) noteEl.value = cart.note || '';
      syncAgeGate();
    }

    function setLoading(on) { if (body) body.classList.toggle('is-loading', on); }
    function load() {
      if (!window.fetch) return;
      setLoading(true);
      fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { render(c); setLoading(false); })
        .catch(function () { setLoading(false); });
    }
    function changeQty(key, qty) {
      if (!window.fetch) return;
      setLoading(true);
      fetch(root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function (c) { render(c); setLoading(false); document.dispatchEvent(new CustomEvent('ep:cart:changed')); })
        .catch(function () { setLoading(false); });
    }

    function openDrawer() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ep-cd-lock');
      load();
      var x = drawer.querySelector('[data-ep-cd-close]');
      if (x && x.focus) setTimeout(function () { x.focus(); }, 60);
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ep-cd-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (drawer) {
      window.__epCartDrawer = true;
      drawer.querySelectorAll('[data-ep-cd-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
      body.addEventListener('click', function (e) {
        var item = e.target.closest('[data-key]');
        if (e.target.closest('[data-ep-cd-remove]') && item) { changeQty(item.getAttribute('data-key'), 0); return; }
        var q = e.target.closest('.ep-cd__qty');
        if (!q) return;
        var inp = q.querySelector('[data-ep-cd-qty]');
        var cur = parseInt(inp.value, 10) || 1;
        if (e.target.closest('[data-ep-cd-minus]')) changeQty(q.getAttribute('data-key'), Math.max(0, cur - 1));
        else if (e.target.closest('[data-ep-cd-plus]')) changeQty(q.getAttribute('data-key'), cur + 1);
      });
      body.addEventListener('change', function (e) {
        var inp = e.target.closest('[data-ep-cd-qty]');
        if (!inp) return;
        var q = inp.closest('.ep-cd__qty');
        changeQty(q.getAttribute('data-key'), Math.max(0, parseInt(inp.value, 10) || 0));
      });
      /* Svuota carrello: cart/clear.js toglie solo le righe; gli attributi delle confezioni
         regalo li ripulisce reconcilePacks al render del carrello vuoto. */
      var clearEl = drawer.querySelector('[data-ep-cd-clear]');
      if (clearEl) clearEl.addEventListener('click', function () {
        if (!window.fetch || !window.confirm(clearEl.getAttribute('data-confirm'))) return;
        setLoading(true);
        fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { render(c); setLoading(false); document.dispatchEvent(new CustomEvent('ep:cart:changed')); })
          .catch(function () { setLoading(false); });
      });
      if (noteEl) {
        noteEl.addEventListener('input', function () {
          clearTimeout(noteTimer);
          noteTimer = setTimeout(function () {
            if (!window.fetch) return;
            fetch(root + 'cart/update.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ note: noteEl.value })
            });
          }, 600);
        });
      }
      /* La checkbox e anche il campo attributes[...] del form checkout: la conferma
         finisce nei dettagli ordine come col popup 18+. Qui si aggiorna solo la data
         al momento del clic (il value renderizzato porta la data di caricamento). */
      [[ageEl, 'Confermata il '], [termsEl, 'Accettate il ']].forEach(function (pair) {
        var el = pair[0], prefix = pair[1];
        if (!el) return;
        el.addEventListener('change', function () {
          if (el.checked) {
            var d = new Date();
            var gg = ('0' + d.getDate()).slice(-2);
            var mm = ('0' + (d.getMonth() + 1)).slice(-2);
            el.value = prefix + gg + '/' + mm + '/' + d.getFullYear();
          }
          syncAgeGate();
        });
      });
      syncAgeGate();
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
      });
      document.addEventListener('ep:cart:open', openDrawer);
    }

    /* Icona carrello nell'header apre il drawer (fallback: link a /cart) */
    document.querySelectorAll('.ep-header__cart').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (window.__epCartDrawer) { e.preventDefault(); openDrawer(); }
      });
    });
    /* "Vai al carrello" del toast apre il drawer se disponibile */
    document.querySelectorAll('[data-ep-open-cart]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (window.__epCartDrawer) { e.preventDefault(); closeToast(); openDrawer(); }
      });
    });

    /* Quando un prodotto viene aggiunto: aggiorna badge + toast; aggiorna il drawer se aperto */
    document.addEventListener('ep:cart:added', function (e) {
      refreshCount();
      openToast(e.detail || {});
      if (drawer && drawer.getAttribute('aria-hidden') === 'false') load();
    });
    /* Evento generico di modifica carrello (rimozioni, qty, ecc.) */
    document.addEventListener('ep:cart:changed', refreshCount);
  })();

  /* ===== Wishlist: badge header + ponte in lettura dall'account ===== */
  (function () {
    var KEY = 'ep-wishlist';
    function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function write(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} }
    function setBadge(n) {
      document.querySelectorAll('[data-ep-wish-count]').forEach(function (el) {
        el.textContent = n;
        el.classList.toggle('is-empty', !n || n < 1);
        if (n > 0) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
      });
    }

    /* Merge: se il cliente loggato ha una wishlist salvata sull'account, unisci al locale */
    var headerEl = document.querySelector('[data-ep-header]');
    var serverRaw = headerEl ? (headerEl.getAttribute('data-customer-wishlist') || '') : '';
    if (serverRaw) {
      var server = serverRaw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var local = read();
      var merged = local.slice();
      server.forEach(function (h) { if (merged.indexOf(h) === -1) merged.push(h); });
      if (merged.length !== local.length) { write(merged); }
    }

    setBadge(read().length);
    document.addEventListener('ep:wishlist:changed', function () { setBadge(read().length); });
  })();

  /* ===== Anteprima rapida =====
     Delega sul document: le card sono rese da piu sezioni diverse e il modale deve
     funzionare comunque, anche per card inserite dopo il caricamento. */
  (function () {
    var modal = document.querySelector('[data-ep-qv-modal]');
    if (!modal) return;

    var panel = modal.querySelector('.ep-qv__panel');
    var elImg = modal.querySelector('[data-ep-qv-img]');
    var elVendor = modal.querySelector('[data-ep-qv-vendor]');
    var elTitle = modal.querySelector('[data-ep-qv-title]');
    var elSpecs = modal.querySelector('[data-ep-qv-specs]');
    var elPrice = modal.querySelector('[data-ep-qv-price]');
    var elLink = modal.querySelector('[data-ep-qv-link]');
    var btnAdd = modal.querySelector('[data-ep-qv-add]');
    var lblAdd = modal.querySelector('[data-ep-qv-add-lbl]');
    var current = null;
    var lastFocus = null;
    var addLabel = lblAdd ? lblAdd.textContent : '';

    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      setTimeout(function () { modal.hidden = true; }, 250);
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      current = null;
    }

    function open(btn) {
      current = btn;
      lastFocus = btn;

      var img = btn.getAttribute('data-img');
      if (elImg) {
        if (img) { elImg.src = img; elImg.alt = btn.getAttribute('data-title') || ''; elImg.hidden = false; }
        else { elImg.hidden = true; elImg.removeAttribute('src'); }
      }
      if (elVendor) elVendor.textContent = btn.getAttribute('data-vendor') || '';
      if (elTitle) elTitle.textContent = btn.getAttribute('data-title') || '';

      if (elSpecs) {
        var bits = [];
        var annata = btn.getAttribute('data-annata');
        var formato = btn.getAttribute('data-formato');
        var grado = btn.getAttribute('data-grado');
        if (annata) bits.push('Annata <b>' + esc(annata) + '</b>');
        if (grado) bits.push('Grado alcolico <b>' + esc(grado) + '%</b>');
        if (formato) bits.push('Formato <b>' + esc(formato) + '</b>');
        elSpecs.innerHTML = bits.join(' &middot; ');
      }

      if (elPrice) {
        var was = btn.getAttribute('data-compare');
        elPrice.innerHTML = (was ? '<span class="ep-qv__was">' + esc(was) + '</span>' : '') + esc(btn.getAttribute('data-price') || '');
      }
      if (elLink) elLink.href = btn.getAttribute('data-url') || '#';
      if (lblAdd) lblAdd.textContent = addLabel;
      if (btnAdd) btnAdd.disabled = false;

      modal.hidden = false;
      void modal.offsetWidth;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      if (panel) panel.scrollTop = 0;
      if (btnAdd && btnAdd.focus) btnAdd.focus();
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest ? e.target.closest('[data-ep-qv]') : null;
      if (trigger) { e.preventDefault(); open(trigger); return; }
      if (e.target.closest && e.target.closest('[data-ep-qv-close]')) { close(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    if (btnAdd) {
      btnAdd.addEventListener('click', function () {
        if (!current) return;
        var id = current.getAttribute('data-vid');
        if (!id || !window.fetch) { window.location.href = current.getAttribute('data-url') || '/'; return; }
        var title = current.getAttribute('data-title') || '';
        var image = current.getAttribute('data-img') || '';
        btnAdd.disabled = true;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: current.getAttribute('data-annata') ? { Annata: current.getAttribute('data-annata') } : undefined }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function () {
          /* toast e badge sono gia gestiti dall'header su questo evento */
          document.dispatchEvent(new CustomEvent('ep:cart:added', { detail: { title: title, image: image } }));
          close();
        }).catch(function () {
          btnAdd.disabled = false;
          if (lblAdd) {
            lblAdd.textContent = 'Riprova';
            setTimeout(function () { lblAdd.textContent = addLabel; }, 1600);
          }
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-ep-hero]').forEach(function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ep-hero-slide]'));
      if (slides.length < 2) return;

      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ep-hero-dot]'));
      var prev = root.querySelector('[data-ep-hero-prev]');
      var next = root.querySelector('[data-ep-hero-next]');
      var index = 0;
      var timer = null;
      var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduce;
      var speed = parseInt(root.getAttribute('data-speed'), 10) || 6000;

      function isVideo(n) { return slides[n].hasAttribute('data-ep-hero-video'); }

      function show(n) {
        index = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
        dots.forEach(function (d, i) {
          var on = i === index;
          d.classList.toggle('is-active', on);
          if (on) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); }
        });
      }

      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      function start() {
        stop();
        if (!autoplay) return;
        timer = setInterval(function () {
          if (isVideo(index)) { stop(); return; } // autoplay in pausa sulle slide video
          show(index + 1);
        }, speed);
      }

      function go(n) { show(n); start(); }

      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-index'), 10) || 0); });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else { start(); }
      });

      show(0);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'ep-newsletter-popup';
    var SESSION_KEY = 'ep-newsletter-popup-submitted';
    var LOCKED_CLASS = 'ep-nlpop-locked';
    var OPEN_CLASS = 'ep-is-open';
    var FOREVER_DAYS = 3650;

    function ready(fn) {
      if (document.readyState !== 'loading') { fn(); }
      else { document.addEventListener('DOMContentLoaded', fn); }
    }

    function isSuppressed() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return false;
        var until = parseInt(raw, 10);
        if (isNaN(until)) return false;
        if (Date.now() > until) {
          window.localStorage.removeItem(STORAGE_KEY);
          return false;
        }
        return true;
      } catch (e) {
        return false;
      }
    }

    function suppressFor(days) {
      try {
        var n = parseInt(days, 10);
        if (isNaN(n) || n < 1) n = 30;
        window.localStorage.setItem(STORAGE_KEY, String(Date.now() + n * 24 * 60 * 60 * 1000));
      } catch (e) {}
    }

    function sessionFlag(value) {
      try {
        if (value === true) { window.sessionStorage.setItem(SESSION_KEY, '1'); return true; }
        if (value === false) { window.sessionStorage.removeItem(SESSION_KEY); return false; }
        return !!window.sessionStorage.getItem(SESSION_KEY);
      } catch (e) {
        return false;
      }
    }

    /* L'age gate e' "libero" quando non blocca piu' lo scroll e o ha marcato <html> con
       ep-age-gate-ok (conferma appena data o gia' in memoria) o non e' proprio nel DOM
       (sezione disattivata, oppure nodo gia' rimosso dopo la conferma). */
    function ageGateClear() {
      var html = document.documentElement;
      if (html.classList.contains(LOCKED_CLASS)) return false;
      if (html.classList.contains('ep-age-gate-locked')) return false;
      if (html.classList.contains('ep-age-gate-ok')) return true;
      return !document.querySelector('[data-ep-age-gate]');
    }

    function whenAgeGateClear(fn) {
      if (ageGateClear()) { fn(); return null; }
      var observer = new MutationObserver(function () {
        if (!ageGateClear()) return;
        observer.disconnect();
        fn();
      });
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true
      });
      return observer;
    }

    function focusables(root) {
      var list = root.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      return Array.prototype.filter.call(list, function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
      });
    }

    function init(scope) {
      var root = (scope || document).querySelector('[data-ep-nlpop]');
      if (!root || root.hasAttribute('data-ep-nlpop-ready')) return;
      root.setAttribute('data-ep-nlpop-ready', '');

      var card = root.querySelector('[data-ep-nlpop-card]');
      var closeBtn = root.querySelector('[data-ep-nlpop-close]');
      var backdrop = root.querySelector('[data-ep-nlpop-backdrop]');
      var emailInput = root.querySelector('[data-ep-nlpop-email]');
      var successBox = root.querySelector('[data-ep-nlpop-success]');
      var errorBox = root.querySelector('[data-ep-nlpop-err]');
      var form = root.querySelector('form');
      var designMode = !!(window.Shopify && window.Shopify.designMode);

      var timer = null;
      var closeTimer = null;
      var observer = null;
      var lastFocus = null;
      var isOpen = false;
      var subscribed = false;

      function lock() { document.documentElement.classList.add(LOCKED_CLASS); }
      function unlock() { document.documentElement.classList.remove(LOCKED_CLASS); }

      function open() {
        if (isOpen) return;
        isOpen = true;
        lastFocus = document.activeElement;
        if (closeTimer) { window.clearTimeout(closeTimer); closeTimer = null; }
        root.hidden = false;
        lock();
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { root.classList.add(OPEN_CLASS); });
        });
        var target = emailInput || successBox || closeBtn;
        if (target) {
          try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
        }
      }

      function close(persist) {
        if (!isOpen) return;
        isOpen = false;
        /* Chi si e' appena iscritto ha gia' la memoria "per sempre": non accorciarla. */
        if (persist !== false && !subscribed) suppressFor(root.getAttribute('data-remember-days'));
        root.classList.remove(OPEN_CLASS);
        unlock();
        closeTimer = window.setTimeout(function () { root.hidden = true; }, 340);
        if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
          try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); }
        }
      }

      closeBtn && closeBtn.addEventListener('click', function () { close(true); });
      backdrop && backdrop.addEventListener('click', function () { close(true); });

      root.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          event.stopPropagation();
          close(true);
          return;
        }
        if (event.key !== 'Tab' || !card) return;
        var items = focusables(card);
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      /* L'invio ricarica la pagina: si marca la sessione per riconoscere, al ritorno con
         ?customer_posted=true, che l'iscrizione e' partita da QUESTO popup e non dalla
         banda newsletter in home (che usa lo stesso form 'customer'). */
      form && form.addEventListener('submit', function () { sessionFlag(true); });

      document.addEventListener('shopify:section:unload', function (event) {
        if (!event.target || !event.target.contains(root)) return;
        if (timer) window.clearTimeout(timer);
        if (closeTimer) window.clearTimeout(closeTimer);
        if (observer) observer.disconnect();
        unlock();
      });

      /* Ritorno dal POST: il successo lo dichiara Liquid (form.posted_successfully?),
         qui si decide solo se riaprire il popup per farlo vedere. */
      var cameBackFromPost = window.location.search.indexOf('customer_posted=true') !== -1;
      var mine = sessionFlag();

      if (successBox && mine) {
        sessionFlag(false);
        subscribed = true;
        suppressFor(FOREVER_DAYS);
        observer = whenAgeGateClear(open);
        return;
      }
      if (errorBox && mine) {
        observer = whenAgeGateClear(open);
        return;
      }
      if (successBox && cameBackFromPost && !mine) {
        /* Iscrizione avvenuta da un altro form 'customer' della pagina: non riaprire. */
        return;
      }

      /* data-subscribed: cliente loggato e gia' iscritto alle email (lo dichiara Liquid). Il
         controllo sta qui e non in Liquid perche' chi si iscrive da loggato deve comunque
         rivedere il popup col messaggio di conferma al ritorno dal POST (ramo sopra). */
      if (!designMode && (isSuppressed() || root.hasAttribute('data-subscribed'))) {
        root.parentNode && root.parentNode.removeChild(root);
        return;
      }

      var delay = parseInt(root.getAttribute('data-delay'), 10);
      if (isNaN(delay) || delay < 0) delay = 15;
      if (designMode) delay = 0.3;

      observer = whenAgeGateClear(function () {
        timer = window.setTimeout(open, delay * 1000);
      });
    }

    ready(function () { init(document); });
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-offers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    document.querySelectorAll('[data-ep-offers]').forEach(function (root) {
      var timers = root.querySelectorAll('[data-ep-offers-timer]');
      if (!timers.length) return;
      var end = Date.parse(root.getAttribute('data-end'));
      if (isNaN(end)) {
        timers.forEach(function (t) { t.style.display = 'none'; });
        return;
      }
      var labels = root.querySelectorAll('[data-ep-offers-timer] .t');
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          timers.forEach(function (t) { t.style.display = 'none'; });
          clearInterval(id);
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor(diff / 3600000) % 24;
        var m = Math.floor(diff / 60000) % 60;
        var s = Math.floor(diff / 1000) % 60;
        var txt = d + ' g. ' + pad(h) + ' : ' + pad(m) + ' : ' + pad(s);
        labels.forEach(function (el) { el.textContent = txt; });
      }
      tick();
      var id = setInterval(tick, 1000);
    });
  })();

  /* Carosello mobile (<= 749px): scroll nativo con snap, frecce e puntini. */
  (function () {
    var MOBILE = '(max-width: 749px)';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initCarousel(root) {
      if (root.getAttribute('data-ep-offers-ready') === 'true') return;
      root.setAttribute('data-ep-offers-ready', 'true');

      var track = root.querySelector('.ep-offers__grid');
      var controls = root.querySelector('[data-ep-offers-controls]');
      if (!track || !controls) return;

      var cards = Array.prototype.slice.call(track.querySelectorAll('.ep-offers__card'));
      if (cards.length < 2) {
        controls.style.display = 'none';
        return;
      }

      var dots = Array.prototype.slice.call(controls.querySelectorAll('[data-ep-offers-dot]'));
      var prev = controls.querySelector('[data-ep-offers-prev]');
      var next = controls.querySelector('[data-ep-offers-next]');
      var index = 0;

      function syncArrows() {
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= cards.length - 1;
      }

      function setActive(n) {
        index = n;
        dots.forEach(function (d, i) {
          var on = i === index;
          d.classList.toggle('is-active', on);
          if (on) {
            d.setAttribute('aria-current', 'true');
          } else {
            d.removeAttribute('aria-current');
          }
        });
        syncArrows();
      }

      /* Mentre e in corso uno scorrimento comandato da frecce o puntini, il calcolo
         dal centro va sospeso: altrimenti le card intermedie riaccenderebbero il
         puntino precedente per un istante. Un tocco dell'utente riprende il controllo. */
      var locked = false;
      var lockTimer = null;
      var ticking = false;

      function unlock() {
        locked = false;
        if (lockTimer) { clearTimeout(lockTimer); lockTimer = null; }
      }

      function goTo(n) {
        n = Math.max(0, Math.min(cards.length - 1, n));
        var card = cards[n];
        var left = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
        if (left < 0) left = 0;
        var behavior = reduce.matches ? 'auto' : 'smooth';
        if (typeof track.scrollTo === 'function') {
          track.scrollTo({ left: left, behavior: behavior });
        } else {
          track.scrollLeft = left;
        }
        setActive(n);
        locked = true;
        if (lockTimer) clearTimeout(lockTimer);
        lockTimer = setTimeout(unlock, 700);
      }

      if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { goTo(i); });
      });

      /* Il puntino attivo segue la posizione reale del nastro: vince la card il cui centro
         e piu vicino al centro del track, ricalcolato su requestAnimationFrame. Cosi segue
         il dito senza ritardo. Prima c'era una IntersectionObserver con soglia 0.75, che
         aggiornava solo a movimento quasi concluso e, durante lo scorrimento animato,
         riaccendeva per un istante il puntino della card precedente. */
      function nearestIndex() {
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0;
        var bestD = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var c = cards[i];
          var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid);
          if (d < bestD) { bestD = d; best = i; }
        }
        return best;
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          if (locked) return;
          var i = nearestIndex();
          if (i !== index) setActive(i);
        });
      }

      track.addEventListener('scroll', onScroll, { passive: true });
      track.addEventListener('touchstart', unlock, { passive: true });
      track.addEventListener('pointerdown', unlock, { passive: true });
      if ('onscrollend' in window) track.addEventListener('scrollend', unlock);

      window.addEventListener('resize', syncArrows);
      if (window.matchMedia(MOBILE).matches) track.scrollLeft = 0;
      setActive(0);
    }

    function init(scope) {
      var node = scope || document;
      if (node.nodeType === 1 && node.hasAttribute && node.hasAttribute('data-ep-offers')) {
        initCarousel(node);
        return;
      }
      node.querySelectorAll('[data-ep-offers]').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    /* Theme editor: la sezione viene ri-renderizzata da zero. */
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.currentScript ? document.currentScript.closest('.shopify-section') : document;
    function scope(sel) { return (root || document).querySelectorAll(sel); }

    document.querySelectorAll('[data-ep-brand-logo]').forEach(function (img) {
      var fallback = img.getAttribute('data-ep-logo-fallback');
      var triedFallback = false;
      function onError() {
        if (fallback && !triedFallback && img.getAttribute('src') !== fallback) {
          triedFallback = true;
          img.setAttribute('src', fallback);
          return;
        }
        img.remove();
      }
      img.addEventListener('error', onError);
      if (!img.getAttribute('src')) { img.remove(); return; }
      if (img.complete && img.naturalWidth === 0) { onError(); }
    });

    var mainImg = document.getElementById('ep-pdp-img');
    document.querySelectorAll('[data-ep-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        document.querySelectorAll('[data-ep-thumb]').forEach(function (x) { x.classList.remove('is-on'); });
        t.classList.add('is-on');
        if (mainImg) mainImg.src = t.getAttribute('data-src');
      });
    });

    var lb = document.querySelector('[data-ep-lb]');
    if (lb) {
      var lbImg = lb.querySelector('[data-ep-lb-img]');
      var lbCount = lb.querySelector('[data-ep-lb-count]');
      var lbOpener = document.querySelector('[data-ep-lb-open]');
      var lbThumbs = [].slice.call(document.querySelectorAll('[data-ep-thumb]'));
      var shots = [];
      var lbAt = 0;
      var lbLast = null;

      if (lbThumbs.length) {
        lbThumbs.forEach(function (t) {
          var z = t.getAttribute('data-zoom');
          if (z) shots.push(z);
        });
      } else if (lbOpener) {
        var only = lbOpener.getAttribute('data-zoom');
        if (only) shots.push(only);
      }

      var lbShow = function (i) {
        if (!shots.length) return;
        lbAt = (i + shots.length) % shots.length;
        if (lbImg) lbImg.src = shots[lbAt];
        if (lbCount) lbCount.textContent = (lbAt + 1) + ' / ' + shots.length;
      };
      var lbClose = function () {
        lb.classList.remove('is-open');
        lb.setAttribute('aria-hidden', 'true');
        setTimeout(function () { lb.hidden = true; }, 250);
        document.documentElement.style.overflow = '';
        if (lbLast && lbLast.focus) lbLast.focus();
      };
      var lbOpen = function () {
        if (!shots.length) return;
        lbLast = document.activeElement;
        lb.hidden = false;
        lb.setAttribute('aria-hidden', 'false');
        lbShow(lbAt);
        requestAnimationFrame(function () { lb.classList.add('is-open'); });
        document.documentElement.style.overflow = 'hidden';
        var c = lb.querySelector('.ep-lb__close');
        if (c && c.focus) c.focus();
      };

      if (lbOpener) lbOpener.addEventListener('click', lbOpen);
      lb.querySelectorAll('[data-ep-lb-close]').forEach(function (b) { b.addEventListener('click', lbClose); });

      var lbPrev = lb.querySelector('[data-ep-lb-prev]');
      var lbNext = lb.querySelector('[data-ep-lb-next]');
      if (lbPrev) lbPrev.addEventListener('click', function () { lbShow(lbAt - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { lbShow(lbAt + 1); });

      lbThumbs.forEach(function (t, i) { t.addEventListener('click', function () { lbAt = i; }); });

      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') { lbClose(); return; }
        if (e.key === 'ArrowLeft') lbShow(lbAt - 1);
        if (e.key === 'ArrowRight') lbShow(lbAt + 1);
      });
    }

    document.querySelectorAll('[data-ep-qty]').forEach(function (q) {
      var val = q.querySelector('[data-ep-qval]');
      q.querySelector('[data-ep-qminus]').addEventListener('click', function () {
        val.value = Math.max(1, (parseInt(val.value, 10) || 1) - 1);
      });
      q.querySelector('[data-ep-qplus]').addEventListener('click', function () {
        val.value = (parseInt(val.value, 10) || 1) + 1;
      });
    });

    var KEY = 'ep-wishlist';
    function readWish() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function writeWish(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} }
    function syncWish(btn, list) { btn.classList.toggle('is-on', list.indexOf(btn.getAttribute('data-handle')) !== -1); }
    document.querySelectorAll('.ep-pdp__wish[data-ep-fav]').forEach(function (b) { syncWish(b, readWish()); });
    document.querySelectorAll('.ep-pdp__wish[data-ep-fav]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        var h = b.getAttribute('data-handle'); var list = readWish(); var i = list.indexOf(h);
        if (i === -1) { list.push(h); } else { list.splice(i, 1); }
        writeWish(list); syncWish(b, list);
        document.dispatchEvent(new CustomEvent('ep:wishlist:changed'));
      });
    });

    var form = document.getElementById('ep-pdp-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;        e.preventDefault();
        var btns = document.querySelectorAll('[data-ep-add]');
        var data = new FormData(form);
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function () {
          btns.forEach(function (btn) {
            var lbl = btn.querySelector('.ep-pdp__add-lbl');
            if (lbl) { var o = lbl.textContent; lbl.textContent = 'Aggiunto ✓'; setTimeout(function () { lbl.textContent = o; }, 1400); }
          });
          var tEl = document.querySelector('.ep-pdp__title');
          var iEl = document.getElementById('ep-pdp-img');
          document.dispatchEvent(new CustomEvent('ep:cart:added', { detail: {
            title: tEl ? tEl.textContent.trim() : '',
            image: iEl ? iEl.currentSrc || iEl.src : ''
          } }));
        }).catch(function () { form.submit(); });
      });
    }

    var sticky = document.querySelector('[data-ep-sticky]');
    var anchor = document.querySelector('.ep-pdp__actions');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.setAttribute('aria-hidden', en.isIntersecting ? 'true' : 'false'); });
      }, { rootMargin: '0px 0px -60px 0px' });
      io.observe(anchor);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-related"] && !Shopify.designMode) return;
  try {
    
  /* Carosello mobile (<= 749px): scroll nativo con snap, frecce e puntini.
     Stessa logica di ep-offers: il puntino attivo segue la card piu vicina al centro del track. */
  (function () {
    var MOBILE = '(max-width: 749px)';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initCarousel(root) {
      if (root.getAttribute('data-ep-related-ready') === 'true') return;
      root.setAttribute('data-ep-related-ready', 'true');

      var track = root.querySelector('[data-ep-related-track]');
      var controls = root.querySelector('[data-ep-related-controls]');
      if (!track || !controls) return;

      var cards = Array.prototype.slice.call(track.querySelectorAll('.ep-pcard'));
      if (cards.length < 2) {
        controls.style.display = 'none';
        return;
      }

      var dots = Array.prototype.slice.call(controls.querySelectorAll('[data-ep-related-dot]'));
      var prev = controls.querySelector('[data-ep-related-prev]');
      var next = controls.querySelector('[data-ep-related-next]');
      var index = 0;

      function syncArrows() {
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= cards.length - 1;
      }

      function setActive(n) {
        index = n;
        dots.forEach(function (d, i) {
          var on = i === index;
          d.classList.toggle('is-active', on);
          if (on) {
            d.setAttribute('aria-current', 'true');
          } else {
            d.removeAttribute('aria-current');
          }
        });
        syncArrows();
      }

      /* Durante uno scorrimento comandato da frecce o puntini il calcolo dal centro va
         sospeso, altrimenti le card intermedie riaccendono il puntino precedente. */
      var locked = false;
      var lockTimer = null;
      var ticking = false;

      function unlock() {
        locked = false;
        if (lockTimer) { clearTimeout(lockTimer); lockTimer = null; }
      }

      function goTo(n) {
        n = Math.max(0, Math.min(cards.length - 1, n));
        var card = cards[n];
        var left = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
        if (left < 0) left = 0;
        var behavior = reduce.matches ? 'auto' : 'smooth';
        if (typeof track.scrollTo === 'function') {
          track.scrollTo({ left: left, behavior: behavior });
        } else {
          track.scrollLeft = left;
        }
        setActive(n);
        locked = true;
        if (lockTimer) clearTimeout(lockTimer);
        lockTimer = setTimeout(unlock, 700);
      }

      if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { goTo(i); });
      });

      function nearestIndex() {
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0;
        var bestD = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var c = cards[i];
          var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid);
          if (d < bestD) { bestD = d; best = i; }
        }
        return best;
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          if (locked) return;
          var i = nearestIndex();
          if (i !== index) setActive(i);
        });
      }

      track.addEventListener('scroll', onScroll, { passive: true });
      track.addEventListener('touchstart', unlock, { passive: true });
      track.addEventListener('pointerdown', unlock, { passive: true });
      if ('onscrollend' in window) track.addEventListener('scrollend', unlock);

      window.addEventListener('resize', syncArrows);
      if (window.matchMedia(MOBILE).matches) track.scrollLeft = 0;
      setActive(0);
    }

    function init(scope) {
      var node = scope || document;
      if (node.nodeType === 1 && node.hasAttribute && node.hasAttribute('data-ep-related')) {
        initCarousel(node);
        return;
      }
      node.querySelectorAll('[data-ep-related]').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    /* Theme editor: la sezione viene ri-renderizzata da zero. */
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var section = document.querySelector('[data-ep-wishlist]');
    if (!section) return;
    var grid = section.querySelector('[data-ep-wl-grid]');
    var emptyEl = section.querySelector('[data-ep-wl-empty]');
    var loadEl = section.querySelector('[data-ep-wl-loading]');
    var countEl = section.querySelector('[data-ep-wl-count]');
    var KEY = 'ep-wishlist';

    function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function updateCount(n) { if (countEl) countEl.textContent = n ? '(' + n + ')' : ''; }
    function showEmpty(on) { if (emptyEl) emptyEl.hidden = !on; if (grid) grid.hidden = on; }
    function drop(h) {
      try { var l = read(); var i = l.indexOf(h); if (i > -1) { l.splice(i, 1); localStorage.setItem(KEY, JSON.stringify(l)); } } catch (e) {}
    }

    function build() {
      var handles = read();
      updateCount(handles.length);
      if (handles.length === 0) { grid.innerHTML = ''; if (loadEl) loadEl.hidden = true; showEmpty(true); return; }
      showEmpty(false);
      grid.innerHTML = '';
      if (loadEl) loadEl.hidden = false;
      var pending = handles.length;
      function done() { pending--; if (pending <= 0) { if (loadEl) loadEl.hidden = true; if (!grid.children.length) showEmpty(true); updateCount(read().length); } }
      handles.forEach(function (h) {
        fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=ep-wishlist-item')
          .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var card = doc.querySelector('.ep-pcard');
            if (card) {
              var fav = card.querySelector('[data-ep-fav]');
              if (fav) fav.classList.add('is-on');
              var cell = document.createElement('div');
              cell.className = 'ep-wl__cell';
              cell.setAttribute('data-wl-handle', h);
              cell.appendChild(card);
              grid.appendChild(cell);
            } else { drop(h); }
          })
          .catch(function () { drop(h); })
          .then(done);
      });
    }

    /* Cuore cliccato (gestito dal JS della card) → rimuovi le card non più in wishlist */
    document.addEventListener('ep:wishlist:changed', function () {
      var handles = read();
      updateCount(handles.length);
      if (!grid) return;
      Array.prototype.slice.call(grid.querySelectorAll('[data-wl-handle]')).forEach(function (cell) {
        if (handles.indexOf(cell.getAttribute('data-wl-handle')) === -1) cell.remove();
      });
      if (!grid.children.length) showEmpty(true);
    });

    build();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
